import { render, staticRenderFns } from "./ImportShipmentSettlementOrders.vue?vue&type=template&id=49908454&scoped=true"
import script from "./ImportShipmentSettlementOrders.vue?vue&type=script&lang=js"
export * from "./ImportShipmentSettlementOrders.vue?vue&type=script&lang=js"
import style0 from "./ImportShipmentSettlementOrders.vue?vue&type=style&index=0&id=49908454&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49908454",
  null
  
)

export default component.exports